import { CommonModule } from '@angular/common';
import { Component, NgModule } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { VideoReportComponent } from '../../../../components/personnel-component/student-components/video-report/video-report.component';
import { FlashcardReportComponent } from '../../../../components/personnel-component/student-components/flashcard-report/flashcard-report.component';
import { TestsReportComponent } from '../../../../components/personnel-component/student-components/tests-report/tests-report.component';
import { StaffStudentCommonProfileViewComponent } from "../../../../components/personnel-component/staff-student-common-profile-view/staff-student-common-profile-view.component";
import { StudentApiServiceService } from '../student-api-service.service';



@Component({
  selector: 'app-student-details',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, VideoReportComponent, FlashcardReportComponent, TestsReportComponent, StaffStudentCommonProfileViewComponent],
  templateUrl: './student-details.component.html',
  styleUrl: './student-details.component.css'
})
export class StudentDetailsComponent {

  currentTab = 'video';
  tabs = [
    { name: 'Video', value: 'video' },
    { name: 'Flashcard', value: 'flashcard' },
    { name: 'AI Test', value: 'ai-test' },
  ];


  studentProfileData: any = {}
  studentId: string = '';
  isFetching: boolean = false;

  constructor(private activatedRoute: ActivatedRoute,private studentService: StudentApiServiceService) { // Replace 'any' with the actual service type
    this.activatedRoute.params.subscribe(params => {
      this.studentId = params['id'];
    });
  }

  ngOnInit() {
    this.getData();
  }

  getData(){
    this.isFetching = true;
    this.studentService.getStudentById(this.studentId).subscribe({
      next: (res) => {
        this.studentProfileData = res.data;
        this.isFetching = false;
      },
      error: (error) => {
        console.error('Error fetching student profile:', error);
        this.isFetching = false;
      }
    });


  }


}
